export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/fax.d17ec42d-3866c7.png";